export var apiUrl = 
// process.env.NODE_ENV === "production"
// ?
"https://api.violympictinhoctre.vn/api/Containers/images/download/";
// :
// "http://localhost:3000/api/Containers/images/download/";
export var errorMessage = "Đã có lỗi xảy ra, vui lòng thử lại";
export var UrlApi = 
// process.env.NODE_ENV === "production"
// ?
"https://api.violympictinhoctre.vn/api";
// :
// "http://localhost:3000/api";
export var au1h10k3N = "DSu1ReSvBjrxfq4FYf0afSssWvMDBHcyZ2lcWRssqBrqaATDBLBGE6MCBRi2HPT2";
export var SCRATCH = "SCRATCH";
export var MULTIPLE_CHOICE = "MULTIPLE_CHOICE";
export var MIX = "MIX";
//type user
export var STUDENT = 'STUDENT';
export var TEACHER = 'TEACHER';
export var URL_BASE = "https://violympictinhoctre.vn/";
// export const URL_BASE = 'http://localhost:3024'
